module.exports = __webpack_public_path__ + "img/tutorial-private-gallery.c1059a70.png";